import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useOauthHandleNew } from "src/welcome/data-access/useOauthHandleNew";
import { useProcessOAuthSuccess } from "src/welcome/data-access/useProcessOAuthSuccess";
import useCancelNamePurchase from "src/namePurchase/data-access/useCancelNamePurchase";
import { OAuthModes } from "src/welcome/types";

function OAuthNew() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const mode: string | null = searchParams.get("mode");
  const code: string | null = searchParams.get("code");
  const state: string | null = searchParams.get("state");
  const errorDescription: string | null = searchParams.get("error_description");
  const isLogin: boolean = mode?.startsWith("login-") || false;
  const {} = useOauthHandleNew(mode, code, state, errorDescription, isLogin);
  const { data, isLoading } = useProcessOAuthSuccess(!isLogin);
  const { mutate: cancelNamePurchase } = useCancelNamePurchase({
    nameTitlePurchaseAppId: data?.data?.nameTitlePurchaseAppId ?? "",
  });
  useEffect(() => {
    if (
      mode == OAuthModes.LOGOUT_CANCEL_NAME_TITLE_APP &&
      !isLoading &&
      data?.data?.nameTitlePurchaseAppId
    ) {
      cancelNamePurchase();
    }
  }, [data, isLoading, mode]);

  return (
    <Box>
      <Typography variant="body1">
        {t("Περιμένετε να γίνει η διασταύρωση των στοιχείων...")}
      </Typography>

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default OAuthNew;
